import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { IdsIconModule, IdsMainButtonModule, IdsLoadingModule, IdsAlertModule } from '@ids/angular';

import { ContentWrapperComponent } from './components/content-wrapper/content-wrapper.component';
import { MicrofrontendErrorComponent } from './components/microfrontend-error/microfrontend-error.component';

@NgModule({
  declarations: [ContentWrapperComponent, MicrofrontendErrorComponent],
  imports: [CommonModule, IdsLoadingModule, IdsMainButtonModule, IdsAlertModule, IdsIconModule],
  exports: [ContentWrapperComponent, MicrofrontendErrorComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ContentWrapperModule {}
